import { useState } from "react";
import backgroundImageUrl from "../assets/aboutimg/photo-1462899006636-339e08d1844e.avif"

const cmsItems = [
    {
        itemId: 1,
        target: "cms-69",
        imageSrc: "/projectsimg/main/wtc-featured-800x600.jpg",
        link: "/projects/world-trade-centre",
        title: "World Trade Centre, Muscat",
        description: "The ultimate corporate, leisure, entertainment and shopping destination in Oman...",
        posttags: [
            { tag: "Project Management" },
            { tag: "Client Representative" }
        ]
    },
        {
        itemId: 2,
        target: "cms-69",
        imageSrc: "/projectsimg/main/Alila-featured-800x600.jpg",
        link: "/projects/alila-Salalah-Hotel",
        title: "Alila Salalah Hotel & Resort / Hinu Bay, Mirbat",
        description: "A luxury boutique 5-star beachfront resort in Mirbat, Salalah offering guests a range of...",
        posttags: [
            { tag: "Project Management" },
            { tag: "Client Representative" },
            { tag: "+" }
        ]
    },
  
    {
        itemId: 3,
        target: "cms-68",
        imageSrc: "/projectsimg/main/20190819_190358-800x600.jpg",
        link: "/projects/mall-of-muscat",
        title: "Mall of Muscat",
        description: "A mixed use & hospitality building and one of the largest shopping malls in Oman...",
        posttags: [
            { tag: "Project Management" },
            { tag: "Client Representative" },
            { tag: "+" }
        ]
    },
    {
        itemId: 4,
        target: "cms-68",
        imageSrc: "/projectsimg/main/20190519_220029-800x600.jpg",
        link: "/projects/oman-aquarium-mall-of-muscat",
        title: "Oman Aquarium, Mall of Muscat",
        description: "Opened as part of the Mall of Muscat on April 15, 2019, it is the largest aquarium in the Middle...",
        posttags: [
            { tag: "Project Management" },
            { tag: "Client Representative" }
        ]
    },
    {
        itemId: 5,
        target: "cms-68",
        imageSrc: "/projectsimg/main/Bait-Al-Reem-600x450.jpg",
        link: "/projects/bait-al-reem",
        title: "Bait Al Reem – Business Centre, Ministries District",
        description: "A corporate building, located in the heart of Al Khuwair. Offering high end office spaces designed with state-of-the-art technology.",
        posttags: [
            { tag: "Project Management" },
            { tag: "Client Representative" },
            { tag: "+"}
        ]
    },

    {
        itemId: 6,
        target: "cms-68",
        imageSrc: "/projectsimg/main/HAI-AL-NASEEM-60-600x450.jpg",
        link: "/projects/hai-al-naseem",
        title: "Hai Al Naseem, Barka",
        description: "An integrated residential compound and commercial complexes in Barka..",
        posttags: [
            { tag: "Project Management" },
            { tag: "Government Representative"}
        ]
    },
     {
        itemId: 7,
        target: "cms-68",
        imageSrc: "/projectsimg/main/20140203_155804-600x450.jpg",
        link: "/projects/ahli-bank-head-office-building-wattayah",
        title: "Ahli Bank Head Office Building, Wattayah",
        description: "A luxury rA unique banking building designed with state-of-the-art technology office spaces...",
        posttags: [
            { tag: "Project Management" },
            { tag: "Client Representative" }
        ]
    },
    {
        itemId: 8,
        target: "cms-68",
        imageSrc: "/projectsimg/main/426af371-1c1a-4593-bcde-6c00e3aee8c7-1-600x450.jpg",
        link: "/projects/sohar-china-downtown",
        title: "Sohar China Downtown",
        description: "A family shopping destination and entertainment Center in Sohar",
        posttags: [
            { tag: "Project Management" }

         
        ]
    },
     {
        itemId: 9,
        target: "cms-68",
        imageSrc: "/projectsimg/main/SnowParkfeatured-800x600.jpg",
        link: "/projects/snow-park-mall-of-muscat",
        title: "Snow Park, Mall of Muscat",
        description: "Another attraction that forms part of the Mall of Muscat is the ‘Snow Park’. ...",
        posttags: [
            { tag: "Project Management" },
            { tag: "Client Representative" }
        ]
    },
  
    {
        itemId: 10,
        target: "cms-68",
        imageSrc: "/projectsimg/anantara-012.png",
        link: "/projects/anantara-resort-hotel-spa",
        title: "Anantara Resort Hotel & Spa",
        description: "A luxury resort on a cliff edge in Jabal Akhdar, offering guests a range of residential units and...",
        posttags: [
            { tag: "Project Management" },
            { tag: "Client Representative" },
            { tag: "+" }
        ]
    },
     {
        itemId: 11,
        target: "cms-68",
        imageSrc: "/projectsimg/d2-1.png",
        link: "/projects/dusit-d2",
        title: "Dusit D2",
        description: "The Dusit D2 is a 4-star hotel building in Seeb, Mabela and being part of the next phase to the Mall of Muscat development. It has been designed in a contemporary architectural style....",
        posttags: [
            { tag: "Project Management" },
            { tag: "Client Representative" },
            { tag: "+" }
        ]
    }

];
const itemsPerPage = 6;


const Projects = () => {
    const [currentPage, setCurrentPage] = useState(1);
    const totalPages = Math.ceil(cmsItems.length / itemsPerPage);

    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentItems = cmsItems.slice(indexOfFirstItem, indexOfLastItem);

    const handlePageChange = (newPage) => {
        if (newPage > 0 && newPage <= totalPages) {
            setCurrentPage(newPage);
        }
    };
    return (
        <div
            data-elementor-type="wp-page"
            data-elementor-id="18"
            className="elementor elementor-101"
        >
            <div
                className="qodef-page-title qodef-m qodef-title--breadcrumbs qodef-alignment--left qodef-vertical-alignment--header-bottom"
                style={{
                    backgroundImage: `linear-gradient(to top, rgba(30, 73, 125, 100%), rgba(96,96,96, 0)),url(${backgroundImageUrl})`,
                    backgroundRepeat: 'no-repeat',
                    // backgroundPosition: `${service?.backgroundPosition}`,
                    backgroundSize: 'cover',
                    position: 'relative',
                }}
            >
                <div className="qodef-m-content qodef-content-grid" style={{ width: '100%', textAlign: 'left', padding: '0 20px' }}>

                    <div itemProp="breadcrumb" className="qodef-breadcrumbs" style={{ color: "#fff", margin: "11px 88px -226px 34px" }}>
                        <a itemProp="url" className="qodef-breadcrumbs-link" href="/" style={{ color: "#fff", textDecoration: "none" }}>
                            <span itemProp="title">Home</span>
                        </a>
                        <span className="qodef-breadcrumbs-separator" style={{ margin: "0 10px", color: "#fff" }}> </span>
                        <span itemProp="title" className="qodef-breadcrumbs-current" style={{ color: "#fff" }}>
                            Projects
                        </span>
                    </div>
                </div>
            </div>
            <div className="elementor-element elementor-element-f511077 pt-110 pb-90 p-tb-tablet-40 e-flex e-con-boxed e-con e-parent e-lazyloaded" data-id="f511077" data-element_type="container">
                <div className="e-con-inner">
                    <div className="elementor-element elementor-element-38975cd elementor-widget elementor-widget-cms_blog_grid" data-id="38975cd" data-element_type="widget" data-widget_type="cms_blog_grid.default">
                        <div className="elementor-widget-container">
                            <div id="cms_blog_grid-38975cd" className="cms-post-grid cms-grid cms-grid-1" data-layout="grid" data-start-page="1" data-max-pages="2" data-total="7" data-perpage="6" data-next-link="https://demo.cmssuperheroes.com/themeforest/finanzia/blog-grid/page/2/">
                                <div className="cms-grid-content d-flex gutterY-20 flex-col-3 flex-col-tablet-2 flex-col-smobile-1 gutterX-40">
                                    {/* <CMSItemsList/> */}
                                    {currentItems.map(({ itemId, imageSrc, link, title, description, posttags }, index) => (
                                        <div className="cms-item item-1" data-target="cms-69" key={itemId}>
                                            <div className="cms--item cms-hover-shadow-2 cms-transition bg-white hover-image-zoom-out">
                                                <div className="cms-post-thumbnail relative overflow-hidden">
                                                    <img
                                                        decoding="async"
                                                        width={840}
                                                        height={560}
                                                        src={imageSrc}
                                                        // data-src="https://demo.cmssuperheroes.com/themeforest/finanzia/wp-content/uploads/blog-6-840x560.webp"
                                                        className="cms-lazy in-h img-cover swiper-nav-vert cms-lazy-loaded ls-is-cached lazyloaded"
                                                        alt={title}
                                                        data-duration=""
                                                        style={{ maxHeight: 226, }}
                                                    />

                                                    <div className="tag-thumb post-tag absolute bottom-right mb-20 mr-20 d-flex  text-13 justify-content-end" style={{rowGap:"6px",columnGap:"5px",left:"35px"}} >
                                                        {posttags.map(({ tag }, ind) => (
                                                            <a href={link} key={ind} className="cms-term tag-thumb-link bg-primary-lighten cms-radius-13 text-13 lh-1 p-tb-5 p-lr-10" >{tag}</a>
                                                        ))}
                                                    </div>
                                                </div>
                                                <div className="cms-content pt-4 pb-33 p-lr-40 p-lr-smobile-20">

                                                    <h3 className="cms-heading text-line-3 text-19 lh-1263 text-accent fw-bold"><a href={link}>{title}</a></h3>
                                                    <div className="cms-excerpt text-15 text-line-3 pt-4 mt-4 bdr-t-1 bdr-divider fw-light" >{description}</div>
                                                    <a href={link} className="cms-link text-15 font-700 cms-hover-move-icon-right pt-30 text-accent">
                                                        View More
                                                        <span className="cms-svg-icon lh-0 cms-eicon text-17 rtl-flip empty-none">
                                                            <svg viewBox="0 0 17 11" xmlns="http://www.w3.org/2000/svg">
                                                                <path d="M11.5248 10.309C11.2695 10.0543 11.2695 9.64136 11.5248 9.38667L14.7676 6.15217H0.653846C0.292737 6.15217 -3.15692e-08 5.86019 0 5.5C3.15692e-08 5.13981 0.292737 4.84783 0.653846 4.84783H14.7676L11.5248 1.61333C11.2695 1.35864 11.2695 0.945707 11.5248 0.691017C11.7802 0.436327 12.1942 0.436328 12.4495 0.691018L16.8085 5.03884C17.0638 5.29353 17.0638 5.70647 16.8085 5.96116L12.4495 10.309C12.1942 10.5637 11.7802 10.5637 11.5248 10.309Z"></path>
                                                                <path d="M11.5248 10.309C11.2695 10.0543 11.2695 9.64136 11.5248 9.38667L14.7676 6.15217H0.653846C0.292737 6.15217 -3.15692e-08 5.86019 0 5.5C3.15692e-08 5.13981 0.292737 4.84783 0.653846 4.84783H14.7676L11.5248 1.61333C11.2695 1.35864 11.2695 0.945707 11.5248 0.691017C11.7802 0.436327 12.1942 0.436328 12.4495 0.691018L16.8085 5.03884C17.0638 5.29353 17.0638 5.70647 16.8085 5.96116L12.4495 10.309C12.1942 10.5637 11.7802 10.5637 11.5248 10.309Z"></path>
                                                            </svg>
                                                        </span>
                                                    </a>
                                                </div>
                                            </div>
                                        </div>

                                    ))}
                                </div>
                                <div className="cms-grid-pagination">
                                    <nav className="navigation posts-pagination ajax">
                                        <div className="posts-page-links d-flex">
                                            {/* <span aria-label="Page 1" aria-current="page" className="page-numbers current" disabled={currentPage === 1}
                                                onClick={() => handlePageChange(currentPage - 1)}>1</span> */}
                                            {Array.from({ length: totalPages }, (_, i) => (<a aria-label="Page 2" href="#2" key={i+1}
                                                className={`page-numbers ${currentPage === i + 1 ? "current" : ""}`}
                                                onClick={() => handlePageChange(i + 1)}>
                                                {i + 1}
                                            </a>))}
                                            <a className="next page-numbers" href="#2" disabled={currentPage === totalPages}
                                                onClick={() => handlePageChange(currentPage + 1)}>
                                                <span className="cms-svg-icon lh-0 cms-eicon text-13 rtl-flip empty-none" >
                                                    <svg viewBox="0 0 13 12" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M13 5.81579C13 5.66652 12.9413 5.52337 12.8368 5.41782L7.63682 0.164846C7.41924 -0.0549486 7.06647 -0.0549486 6.8489 0.164846C6.63132 0.384639 6.63132 0.740997 6.8489 0.960791L11.0978 5.25297L0.557142 5.25297C0.249441 5.25297 0 5.50495 0 5.81579C0 6.12663 0.249441 6.37861 0.557142 6.37861H11.0978L6.8489 10.6708C6.63132 10.8906 6.63132 11.2469 6.8489 11.4667C7.06647 11.6865 7.41924 11.6865 7.63682 11.4667L12.8368 6.21376C12.9413 6.10821 13 5.96506 13 5.81579Z"></path>
                                                        <path d="M13 5.81579C13 5.66652 12.9413 5.52337 12.8368 5.41782L7.63682 0.164846C7.41924 -0.0549486 7.06647 -0.0549486 6.8489 0.164846C6.63132 0.384639 6.63132 0.740997 6.8489 0.960791L11.0978 5.25297L0.557142 5.25297C0.249441 5.25297 0 5.50495 0 5.81579C0 6.12663 0.249441 6.37861 0.557142 6.37861H11.0978L6.8489 10.6708C6.63132 10.8906 6.63132 11.2469 6.8489 11.4667C7.06647 11.6865 7.41924 11.6865 7.63682 11.4667L12.8368 6.21376C12.9413 6.10821 13 5.96506 13 5.81579Z"></path>
                                                    </svg>
                                                </span>
                                            </a>
                                        </div>
                                    </nav>
                                </div>
                                <div className="cms-grid-overlay"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Projects
